export default {
  REGULAR_FOP: 'REGULAR_FOP',
  SUGGESTED_ORDER_FOP: 'SUGGESTED_ORDER_FOP',
};
